<template>
  <div :class="col ? `col-md-${col}` : ''">
    <!-- Start:: Date Picker Input -->
    <div class="input_wrapper picker" v-if="type == 'date'">
      <v-dialog
        ref="dialog"
        persistent
        v-model="DateModalIsActive"
        width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            @input="updateValue($event)"
            :label="placeholder"
            readonly
            prepend-icon="mdi-calendar"
            v-bind="attrs"
            v-model="Datevalue"
            v-on="on"
          ></v-text-field>
          <span
            @click="
              $emit('emptyData', Datevalue);
              Datevalue = '';
            "
            :class="{ show: Datevalue }"
            class="closeIcon"
            ><i class="fas fa-times-circle"></i
          ></span>
        </template>
        <v-date-picker
          :allowedDates="allowedDates"
          @input="updateValue($event, 'DateModalIsActive')"
          v-model="Datevalue"
          scrollable
        >
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="DateModalIsActive = false">
            {{ $t("BUTTONS.cancel") }}
          </v-btn>
          <v-btn text color="primary" @click="$refs.dialog.save(Datevalue)">
            {{ $t("BUTTONS.select") }}
          </v-btn>
        </v-date-picker>
      </v-dialog>
    </div>
    <!-- End:: Date Picker Input -->

    <!-- Start:: Time Picker Input -->
    <div class="input_wrapper" v-else-if="type == 'time'">
      <v-dialog
        ref="dialog"
        v-model="timeModalIsActive"
        :return-value.sync="value"
        width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            :value="value"
            @input="updateValue($event)"
            :label="placeholder"
            readonly
            prepend-icon="mdi-clock-time-four-outline"
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-time-picker
          v-if="timeModalIsActive"
          :value="value"
          format="24hr"
          @input="updateValue($event)"
          full-width
        >
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="timeModalIsActive = false">
            {{ $t("BUTTONS.cancel") }}
          </v-btn>
          <v-btn text color="primary" @click="$refs.dialog.save(value)">
            {{ $t("BUTTONS.select") }}
          </v-btn>
        </v-time-picker>
      </v-dialog>
    </div>
    <!-- End:: Time Picker Input -->
    <!-- Start:: Month Picker Input -->
    <div class="input_wrapper picker" v-else-if="type == 'months'">
      <v-dialog
        ref="dialog"
        persistent
        v-model="MonthModelIsActive"
        width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            :label="placeholder"
            readonly
            @input="updateMonths($event)"
            prepend-icon="mdi-calendar"
            v-bind="attrs"
            v-model="monthValue"
            v-on="on"
          ></v-text-field>
          <span
            @click="
              $emit('emptyData', monthValue);
              monthValue = [];
            "
            :class="{ show: monthValue }"
            class="closeIcon"
            ><i class="fas fa-times-circle"></i
          ></span>
        </template>
        <!-- <v-date-picker v-model="monthValue" type="month"></v-date-picker> -->
        <!-- @input="updateValue($event, 'MonthModelIsActive')" -->
        <v-date-picker
          type="month"
          @input="updateMonths($event)"
          v-model="monthValue"
          :allowed-dates="allowedMonths"
          multiple
          scrollable
        >
          <v-spacer></v-spacer>
          <v-btn
            text
            color="primary"
            @click="
              MonthModelIsActive = false;
              monthValue = [];
            "
          >
            {{ $t("BUTTONS.cancel") }}
          </v-btn>
          <v-btn text color="primary" @click="handleSelect">
            {{ $t("BUTTONS.select") }}
          </v-btn>
        </v-date-picker>
      </v-dialog>
    </div>
    <!-- End:: Month Picker Input -->
  </div>
</template>

<script>
export default {
  name: "BasePickerInput",
  props: {
    type: {
      required: true,
      type: String,
    },
    value: {
      required: true,
    },

    placeholder: {
      required: true,
      type: String,
    },
    validationHint: {
      required: false,
      type: String,
    },
    col: {
      required: false,
      type: String,
    },
    required: {
      required: false,
      type: Boolean,
      default: false,
    },
    allowedDate: {
      required: false,
    },
  },

  data() {
    return {
      DateModalIsActive: false,
      timeModalIsActive: false,
      MonthModelIsActive: false,
      Datevalue: null,
      monthValue: null, //user clicked month
      selectedMonths: [],
    };
  },

  methods: {
    allowedMonths(date) {
      const today = new Date();
      const currentYear = today.getFullYear();
      const currentMonth = today.getMonth(); // 0 = Jan, 11 = Dec

      const d = new Date(date);
      const year = d.getFullYear();
      const month = d.getMonth();

      // ✅ allow only months of current year AND <= current month
      return year === currentYear && month <= currentMonth;
    },
    handleSelect() {
      // console.log("this.monthValue", this.monthValue);
      this.$emit("input", this.selectedMonths);
      this.$refs.dialog.save(this.monthValue);
      // console.log("this.selectedMonths", this.selectedMonths);
    },
    updateValue(event, input) {
      this[input] = false;

      this.$emit("getData", event);
      this.$emit("input", event);
    },
    updateMonths(month) {
      // console.log("updateMonths", event);
      // console.log("month", month);
      // console.log("this.monthValue", this.monthValue);
      const index = this.selectedMonths.indexOf(month);
      if (index === -1) {
        this.selectedMonths.push(month);
      } else {
        this.selectedMonths.splice(index, 1);
      }
      this.$emit("getData", month);
      // this.$emit("input", month);
    },
    // updateMonths(month) {
    //   console.log("updateMonths", month);
    //   // ناخد الجزء التاني من التاريخ (الشهر فقط)
    //   const onlyMonth = month[month.length - 1].split("-")[1]; // "2025-05" => "05"

    //   // console.log("month (raw):", month);
    //   // console.log("month (only):", onlyMonth);
    //   console.log("this.selectedMonths", this.selectedMonths);

    //   const index = this.selectedMonths.indexOf(onlyMonth);
    //   if (index === -1) {
    //     this.selectedMonths.push(onlyMonth);
    //   } else {
    //     this.selectedMonths.splice(index, 1);
    //   }

    //   this.$emit("getData", onlyMonth);
    // },
    allowedDates(val) {
      if (this.allowedDate) {
        return val >= new Date(this.allowedDate).toISOString().substr(0, 10);
      } else {
        return val;
      }
    },
  },
  watch: {
    value(newVal) {
      this.Datevalue = newVal;
    },
    // monthValue(newVal) {
    //   this.monthValue = newVal;
    // },
    $route(to) {
      if (to.query.months) {
        this.monthValue = to.query.months.split(",");
      } else {
        this.monthValue = [];
        this.selectedMonths = [];
      }
    },
  },
  mounted() {
    if (this.value) {
      this.Datevalue = this.value;
    }
    if (this.$route.query.months) {
      this.monthValue = this.$route.query.months.split(",");
    }
  },
};
</script>
